import React from 'react';
import { SessionProvider } from 'next-auth/react';
import type { AppProps } from 'next/app';
import type { Session } from 'next-auth';
import type { NormalizedCacheObject } from '@apollo/client';

import { AppFrame } from '@/components/app-frame';

import '../styles/globals.css';

type Props = AppProps<{ session: Session; initialApolloState: NormalizedCacheObject }> & {
  err: never;
};

function MyApp({ Component, pageProps, err }: Props) {
  return (
    <SessionProvider session={pageProps.session}>
      <AppFrame initialApolloState={pageProps.initialApolloState}>
        <Component {...pageProps} err={err} />
      </AppFrame>
    </SessionProvider>
  );
}

export default MyApp;
